import 'dayjs/locale/th'
import dayjs from 'dayjs'
import { timeFn } from './type'

export const times: timeFn = (nbChildren, fn) =>
  Array.from({ length: nbChildren }, (_, key) => fn(key))

export const timestampLocaleString = (date: string, locale = ''): string => {
  switch (locale) {
    case 'th':
      return dayjs(date).add(543, 'year').locale('th').format('DD MMMM YYYY, HH:mm')
    case 'en':
    default:
      return dayjs(date).format('DD MMMM YYYY, HH:mm')
  }
}
